module.exports = __webpack_public_path__ + "a5e81f19cf2c587876fd1bb08ae0249f.png";